import { z } from 'zod';

export const SANDBOX_RESET_RUN_STATUSES = ['QUEUED', 'IN_PROGRESS', 'SUCCEEDED', 'FAILED'] as const;
export type SandboxResetRunStatus = (typeof SANDBOX_RESET_RUN_STATUSES)[number];

export const SandboxResetRunSchema = z.object({
  id: z.string().min(1),
  status: z.enum(SANDBOX_RESET_RUN_STATUSES),
  startedAt: z.iso.datetime(),
  url: z.url(),
});
export type SandboxResetRun = z.infer<typeof SandboxResetRunSchema>;

export const SANDBOX_RESET_DATA_KINDS = ['ANONYMIZED', 'DEBUG'] as const;
export type SandboxResetDataKind = (typeof SANDBOX_RESET_DATA_KINDS)[number];

export const GetSandboxResetResponseSchema = z.object({
  latestRun: SandboxResetRunSchema.nullable(),
  /** A `sandbox data reset` or `sandbox deploy` run is queued or running. */
  busy: z.boolean(),
  /** What the Monday reset makes: the stack's `sandbox:debugData` on `main`. */
  defaultDataKind: z.enum(SANDBOX_RESET_DATA_KINDS),
});
export type GetSandboxResetResponse = z.infer<typeof GetSandboxResetResponseSchema>;

export const StartSandboxResetBodySchema = z.object({ dataKind: z.enum(SANDBOX_RESET_DATA_KINDS) }).strict();
export type StartSandboxResetBody = z.infer<typeof StartSandboxResetBodySchema>;

export const StartSandboxResetResponseSchema = z.discriminatedUnion('outcome', [
  z.object({ outcome: z.literal('STARTED'), run: SandboxResetRunSchema }),
  z.object({ outcome: z.literal('REFUSED'), reason: z.literal('RUN_IN_PROGRESS') }),
]);
export type StartSandboxResetResponse = z.infer<typeof StartSandboxResetResponseSchema>;
